import Dexie, { Table } from 'dexie';
import { VendorInterface, categoryInterface, ProductInterface, BrandInterface } from './types';

export class ImportToolDexie extends Dexie {
  vendors!: Table<Pick<VendorInterface, 'vendors_id'>>;
  categories!: Table<Pick<categoryInterface, 'vendor_products_category'>>;
  brands!: Table<Pick<BrandInterface, 'id'>>;
  selectedProducts!: Table<ProductInterface>;
  editedProducts!: Table<ProductInterface>;

  constructor() {
    super('importTool');

    this.version(4).stores({
      vendors: '&vendors_id',
      categories: '&vendor_products_category',
      brands: '&id,parent,name',
      selectedProducts: '&vendor_products_id',
      editedProducts: '&vendor_products_id, vendor_products_sku, vendor_products_name, vendor_products_category, vendor_products_price, vendor_products_brand',
    });
  }
}

export const dexieDB = new ImportToolDexie();
